
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/hub/templates/header"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='hubComponent-headerFilterRegion'></div>\n<div class='hubComponent-headerActions'>\n  <div class='hubComponent-headerSubscriptionRegion'></div>\n  <div class='hubComponent-headerExpandRegion'></div>\n</div>\n";
},"useData":true});
    }).call(this);
  